import { render } from "./ZaikoEpcListPage.vue?vue&type=template&id=2b526ebc"
import script from "./ZaikoEpcListPage.vue?vue&type=script&lang=js"
export * from "./ZaikoEpcListPage.vue?vue&type=script&lang=js"

import exportComponent from "/w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__